'use client';
import React, { useState } from 'react';
import Navbar from '@/components/Navbar';
import HeroSlider from '@/components/HeroSlider';
import CategoryBar from '@/components/CategoryBar';
import EventGrid from '@/components/EventGrid';
import FeaturedBanner from '@/components/FeaturedBanner';
import InterestCarousel from '@/components/InterestCarousel';
import OrganizerBanner from '@/components/OrganizerBanner';
import NewsSection from '@/components/NewsSection';
import SupportCards from '@/components/SupportCards';
import TestimonialsSection from '@/components/TestimonialsSection';
import SupportedBySection from '@/components/SupportedBySection';
import JoinUsSection from '@/components/JoinUsSection';
import ServingWithPurposeSection from '@/components/ServingWithPurposeSection';
import Footer from '@/components/Footer';

export default function HomePage() {
  const [activeCategory, setActiveCategory] = useState('all');

  return (
    <div className="min-h-screen" style={{ fontFamily: 'Roboto, sans-serif', background: '#FAF7F2' }}>
      {/* Sticky Navbar — transparent over hero */}
      <Navbar transparent={true} />

      {/* Hero Slider — full viewport, behind navbar */}
      <HeroSlider />

      {/* Category Filter Bar — sticky below navbar */}
      <CategoryBar onCategoryChange={setActiveCategory} />

      {/* Event Grid */}
      <div id="discover">
        <EventGrid activeCategory={activeCategory} />
      </div>

      {/* Featured Banner (EventSphere Premium stats) */}
      <FeaturedBanner />

      {/* Browse by Interest Carousel */}
      <InterestCarousel />

      {/* Event Finder + Organizer Banners */}
      <div className="py-4" style={{ background: '#F5EFE6' }}>
        <OrganizerBanner variant="finder" />
        <OrganizerBanner variant="organizer" />
      </div>

      {/* News & Updates Section */}
      <NewsSection />

      {/* Testimonials Section */}
      <TestimonialsSection />

      {/* Supported By Section */}
      <SupportedBySection />

      {/* Serving with Purpose Section */}
      <ServingWithPurposeSection />

      {/* Join Us Section */}
      <JoinUsSection />

      {/* Support Cards */}
      <SupportCards />

      {/* Footer */}
      <Footer />
    </div>
  );
}
